import DASHBOARD_ROUTES from '../../routes';

export default {
    START: DASHBOARD_ROUTES.RECIPIENTS,
    CREATE_CONTACT_GROUP: `${DASHBOARD_ROUTES.RECIPIENTS}/group/create`,
    EDIT_CONTACT_GROUP_CONTACTS: (id: number | string) =>
        `${DASHBOARD_ROUTES.RECIPIENTS}/group/edit-contacts/${id}`,
};
